import React from 'react';
import styled from 'styled-components';

const PRODUCTION_HOST = 'wsv.myseotoolbox.com';
const LOCAL_HOSTS = ['localhost', '127.0.0.1', '[::1]'];

const Bar = styled.div`
    flex: 0 0 auto;
    padding: 4px 12px;
    background: #f59e0b;
    color: #422006;
    font-family: "Inter", system-ui, sans-serif;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    text-align: center;
`;

// One image is built and deployed to every environment, so nothing is baked in at build time and the
// host the app is served from is all there is to read.
export function environmentLabel(hostname) {
    if (hostname === PRODUCTION_HOST) return null;
    return LOCAL_HOSTS.includes(hostname) ? "Local" : "Staging";
}

export default function EnvironmentBanner() {
    const label = environmentLabel(window.location.hostname);

    return label ? <Bar role="status">{label}</Bar> : null;
}
